import React, {FC} from "react";
import {SpriteIconBox, ISpriteIconProps} from "../base/sprite-icon.box";

export const CloseIcon: FC = () => {

  const props: ISpriteIconProps = {
    width: "17px",
    height: "17px",
    sourceX: -945,
    sourceY: -649
  };

  return <SpriteIconBox {...props}/>
};
